import React from 'react'
import { Icon as CommunicationsIcon } from '@enamelai/design-system/icons/Communications'
import { Icon as InTreatmentIcon } from '@enamelai/design-system/icons/In_treatment'
import { Icon as MoneyIcon } from '@enamelai/design-system/icons/Money'
import { Icon as StaffIcon } from '@enamelai/design-system/icons/Staff'
import { Icon as StethoscopeIcon } from '@enamelai/design-system/icons/Stethoscope'
import { Icon as TweakIcon } from '@enamelai/design-system/icons/Tweak'
import { ReactComponent as AnalyticsIcon } from '@assets/images/Settings/settings-nav-analytics.svg'

type NavIcon = React.FC<React.SVGProps<SVGSVGElement>>

export const SETTINGS_NAV_ICONS: Record<string, NavIcon> = {
  'practice-settings': InTreatmentIcon,
  'staff-settings': StaffIcon,
  'clinical-settings': StethoscopeIcon,
  'communications-settings': CommunicationsIcon,
  'accounting-settings': MoneyIcon,
  'reporting-settings': AnalyticsIcon,
  'system-settings': TweakIcon,
}
